// extracted by mini-css-extract-plugin
export default {"container":"styles_container__50laq","title":"styles_title__AwWkh"};